import { render, staticRenderFns } from "./Formter.vue?vue&type=template&id=a044bb4c&scoped=true"
import script from "./Formter.vue?vue&type=script&lang=js"
export * from "./Formter.vue?vue&type=script&lang=js"
import style0 from "./Formter.vue?vue&type=style&index=0&id=a044bb4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a044bb4c",
  null
  
)

export default component.exports